/* Garden of Grace: variant-aware Printify gallery test. Draft theme only. */
(() => {
  const normalize = (s) => (s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const colorNames = ['dark heather','light pink','royal','sand','black','white'];
  const detectColor = (text) => colorNames.find(c => normalize(text).includes(c));

  function selectedColor(root=document) {
    const checked = root.querySelector('input[type="radio"]:checked');
    if (checked) {
      const label = root.querySelector(`label[for="${CSS.escape(checked.id)}"]`);
      const c = detectColor(`${checked.value} ${label?.textContent || ''}`);
      if (c) return c;
    }
    const selects = [...root.querySelectorAll('select')];
    for (const s of selects) {
      const c = detectColor(`${s.name} ${s.options[s.selectedIndex]?.text || ''}`);
      if (c) return c;
    }
    return null;
  }

  function inferGroups(gallery) {
    const items = [...gallery.querySelectorAll('.product-media-container')];
    const images = items.map(el => el.querySelector('img')).filter(Boolean);
    const explicit = images.some(img => detectColor(`${img.alt} ${img.src}`));
    if (explicit) {
      items.forEach(el => {
        const img = el.querySelector('img');
        el.dataset.gogColor = detectColor(`${img?.alt || ''} ${img?.src || ''}`) || '';
      });
      return;
    }
    // Printify currently publishes 36 hoodie mockups as six contiguous groups of six.
    // This fallback is intentionally limited to the But God hoodie to avoid affecting other products.
    if (!/but god/i.test(document.title) || items.length < 36) return;
    const order = ['white','black','sand','light pink','royal','dark heather'];
    items.slice(0,36).forEach((el,i) => { el.dataset.gogColor = order[Math.floor(i/6)] || ''; });
  }

  function apply() {
    const gallery = document.querySelector('media-gallery');
    if (!gallery) return;
    inferGroups(gallery);
    const color = selectedColor(document);
    if (!color) return;
    gallery.querySelectorAll('.product-media-container[data-gog-color]').forEach(el => {
      const own = el.dataset.gogColor;
      el.hidden = !!own && own !== color;
      el.style.display = el.hidden ? 'none' : '';
    });
  }

  document.addEventListener('change', () => setTimeout(apply, 50));
  document.addEventListener('click', () => setTimeout(apply, 80));
  document.addEventListener('DOMContentLoaded', () => setTimeout(apply, 100));
  new MutationObserver(() => setTimeout(apply, 50)).observe(document.documentElement, {subtree:true, childList:true});
})();
